import { SetState } from 'zustand';
import { ValueState } from '@ui5/webcomponents-react';
import { CommonTrainingQueryState } from 'stores/interfaces/CommonQueryState';

export const commonTrainingQueryInitialStateFields = {
  xtmProjectName: '',
  xtmProjectNameValueState: ValueState.None,
  fileName: '',
  fileNameValueState: ValueState.None
};

export const commonTrainingQueryInitialStateValueStates = {
  xtmProjectName: '',
  xtmProjectNameValueState: ValueState.None,
  fileName: '',
  fileNameValueState: ValueState.None
};

export const commonTrainingQueryInitialState = {
  ...commonTrainingQueryInitialStateFields,
  ...commonTrainingQueryInitialStateValueStates,
  fetching: false
};

export const createCommonTrainingQuerySlice = <T extends CommonTrainingQueryState>(
  set: SetState<T>
) => ({
  ...commonTrainingQueryInitialState,
  setXtmProjectName: (value: string) => set(() => ({ xtmProjectName: value })),
  setXtmProjectNameValueState: (value: ValueState) =>
    set(() => ({ xtmProjectNameValueState: value })),

  setFileName: (value: string) => set(() => ({ fileName: value })),
  setFileNameValueState: (value: ValueState) =>
    set(() => ({
      fileNameValueState: value
    })),
  setFetching: (value: boolean) => set(() => ({ fetching: value })),
  resetData: () =>
    set({
      xtmProjectName: '',
      xtmProjectNameValueState: ValueState.None,
      fileName: '',
      fileNameValueState: ValueState.None
    })
});
